module.exports = __webpack_public_path__ + "img/des.b727ebdc.png";